(function () {
  var root = document.documentElement;
  var utilityBar = document.querySelector('[id$="__header-utility-bar"]');
  var header = document.querySelector('.section-header');

  function setOffsets() {
    var utilityHeight = utilityBar ? utilityBar.getBoundingClientRect().height : 0;
    var headerHeight = header ? header.getBoundingClientRect().height : 0;

    root.style.setProperty('--utility-bar-height', utilityHeight + 'px');
    root.style.setProperty('--sticky-header-total-height', (utilityHeight + headerHeight) + 'px');
  }

  setOffsets();
  window.addEventListener('resize', setOffsets);

  if (window.ResizeObserver) {
    var observer = new ResizeObserver(setOffsets);
    if (utilityBar) observer.observe(utilityBar);
    if (header) observer.observe(header);
  }
})();
